import React from 'react'
import Modal from '../../../../core/shared/Modal'
import {Button} from '../../../../core/shared/Button'

export function DiscardChangesModal({isOpen, onCancel, onConfirm}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title="Leave this page?"
      size="md"
      showCloseButton={false}
      closeOnBackdrop={false}
      closeOnEsc={false}
      footer={
        <>
          <Button variant="secondary-gray-reg" size="sm" onClick={onCancel}>
            Stay on page
          </Button>
          <Button variant="secondary-danger" size="sm" onClick={onConfirm}>
            Leave & discard
          </Button>
        </>
      }
    >
      <p style={{margin: 0, fontSize: 14, lineHeight: 1.6}}>
        You have unsaved proposal option data. If you leave now, all changes
        will be lost and your proposal options will be reset.
      </p>
    </Modal>
  )
}
